/**

 **/
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var template = require('ui.plugins/gridView/filter/templates/gridViewFilterLayout.tmpl');
    var Logger = require('logger');
    var Button = require("ui/button/Button");
    var PositionUtils = require('ui/PositionUtils');

    var MultiselectFilter = require("ui.plugins/gridView/filter/filter-types/views/MultiselectFilter");
    var ToggleFilter = require("ui.plugins/gridView/filter/filter-types/views/ToggleFilter");
    var TimeFrameFilter = require("ui.plugins/gridView/filter/filter-types/views/TimeFrameFilter");

    var FILTER_TYPES = {
        MULTISELECT: "multiselect",
        TOGGLE: "toggle",
        TIMEFRAME: "timeFrame"
    };

    var FILTER_OFFSET = {
        TOP: 3,
        LEFT: 15
    };

    var VIEW_TYPES = {};
    VIEW_TYPES[FILTER_TYPES.MULTISELECT] = MultiselectFilter;
    VIEW_TYPES[FILTER_TYPES.TOGGLE] = ToggleFilter;
    VIEW_TYPES[FILTER_TYPES.TIMEFRAME] = TimeFrameFilter;

    var GridViewFilterLayout = Marionette.Layout.extend({
        className: "filter-container",
        template: template,
        ui: {

            insideViewContainer: ".filter-inside-view-container",
            resetButton: ".filter-reset-btn",
            filterButton: ".filter-filter-btn"
        },
        regions: {
            insideViewRegion: ".filter-inside-view-container"
        },
        uiComponents: {
            filterButton: {
                type: Button,
                options: {
                    el: "view.ui.filterButton",
                    permutation: Button.PERMUTATION.BTN_PRIMARY
                },
                events: {
                    "click": "_onFilterClick"
                }
            },
            resetButton: {
                type: Button,
                options: {
                    el: "view.ui.resetButton",
                    permutation: Button.PERMUTATION.LINK
                },
                events: {
                    "click": "_onResetClick"
                }
            }
        },
        events: {
            "click .filter-close-btn": "_onCloseButtonClick",
            "clickoutside": "_onClickOutside"
        },

        initialize: function (options) {
            this.logger = Logger.getLogger("GridViewFilterLayout");
            if(_.has(options, "vent") && _.has(options, "filterType") && _.has(options, "filterName") && _.has(options, "targetElement") && (_.has(options, "model") || _.has(options, "collection")) && _.has(options, "filterData")) { //all mandatory properties
                this.vent = options.vent;
                this.filterType = options.filterType; //mandatory
                this.filterName = options.filterName; //mandatory
                this.targetElement = options.targetElement; //mandatory
                this.dataObject = options.model || options.collection; //mandatory
                this.filterData = options.filterData; //mandatory per inside filter
                this.isShowLoader = _.has(options, "isShowLoader") ? options.isShowLoader : false;

                if (!_.has(FILTER_TYPES, options.filterType.toUpperCase())) {
                    this.logger.error("Filter type is not supported", "GridViewFilterLayout:initialize");
                    this.logger.graph({ name: "UIComponents:GridViewFilterLayout:UnsupportedFilterType"});
                }
            }
            else{
                this.logger.error("Missing mandatory property", "GridViewFilterLayout:initialize");
                this.logger.graph({ name: "UIComponents:GridViewFilterLayout:MissingMandatoryProperty"});
            }
        },

        onRender: function () {
            var parentElement = $(".interaction-area-item-wrapper.open").get(0);
            this.$el.appendTo(parentElement);

            this._prepareInsideView();
            this._renderInsideView();
            this._bindEvents();
            this._setPosition();
        },

        _bindEvents: function () {
            this.listenTo(this.vent, "gridView:closeFilter", this._closeView);
        },

        _setPosition: function () {
            PositionUtils.position({
                targetEl: this.targetElement,
                floatingEl: this.$el,
                position: PositionUtils.PositionEntity.POSITION.BOTTOM,
                align: PositionUtils.PositionEntity.ALIGN.LEFT
            }, _.bind(this._onPositionCalculated, this));
        },

        _onPositionCalculated: function (pos) {
            if (pos.isValid) {
                this.$el.addClass(pos.cls);
                var top = pos.top - FILTER_OFFSET.TOP;

                var left = pos.left - FILTER_OFFSET.LEFT;
                if (pos.align === PositionUtils.PositionEntity.ALIGN.RIGHT) {
                    left = pos.left + FILTER_OFFSET.LEFT;
                }

                this.$el.css({"top": top, "left": left});
            }
            else {
                this.logger.error(pos.err);
                this.logger.graph({ name: "UIComponents:GridViewFilterLayout:positionErr"});
            }
        },

        _prepareInsideView: function () {
            if(_.isFunction(this.dataObject.getFilterValue)){
                var filterData = this.filterData;
                var selectedValues = this.dataObject.getFilterValue(this.filterName);
                var FilterTypeView = VIEW_TYPES[this.filterType];

                this.insideView = new FilterTypeView({
                    selectedValues: selectedValues,
                    filterData: filterData
                });
            }
            else{
                this.logger.error("No 'getFilterValue' function found in model", "GridViewFilterLayout:_prepareInsideView");
                this.logger.graph({ name: "UIComponents:GridViewFilterLayout:NoGetFilterValueFunctionOnModel"});
            }
        },

        _renderInsideView: function () {
            if (this.insideView) {
                this.insideViewRegion.show(this.insideView);
            }
        },

        _onFilterClick: function () {
            if(this.isShowLoader) {
                this.vent.trigger("gridView:show:filteringLoader");
                setTimeout(_.bind(function(){
                    this._tableFilterClick();
                }, this), 200); //timeout 200 milsec for rendering loader. To be removed after paging in server
            } else {
                this._tableFilterClick();
            }
        },

        _tableFilterClick: function () {
            if (this.insideView) {
                var selectedValues = this.insideView.getFilterSelection();
                if (_.isFunction(this.dataObject.setFilterValue)) {
                    this.dataObject.setFilterValue(this.filterName, selectedValues);
                }
                else{
                    this.logger.error("No 'setFilterValue' function found in model", "GridViewFilterLayout:_filterCollection");
                    this.logger.graph({ name: "UIComponents:GridViewFilterLayout:NoSetFilterValueFunctionOnModel"});
                }
            }
            this._closeView();
        },

        _onResetClick: function () {
            if (this.insideView) {
                var emptyValue = this.insideView.resetCollectionFilter(); //reset result can be different for different filters
                if (_.isFunction(this.dataObject.setFilterValue)) {
                    this.dataObject.setFilterValue(this.filterName, emptyValue);
                }
                else{
                    this.logger.error("No 'setFilterValue' function found in model", "GridViewFilterLayout:_filterCollection");
                    this.logger.graph({ name: "UIComponents:GridViewFilterLayout:NoSetFilterValueFunctionOnModel"});
                }
            }
            this._closeView();
        },

        _onClickOutside: function (event) { //other close filter options are handled in the outside view (gridView)
            var isClickedOnFilterIcon = $(event.target).hasClass('filter'); //need to check that the outside click is not the click that is creating the filter view
            var isClickedOnDatePickerIcon = $(event.target).hasClass('ui-datepicker-prev') || $(event.target).hasClass('ui-datepicker-next'); // need to check that the outside click is not arrows in the date picker that might went outside the DOM because functionality of jquery.datepicker that re-render the DOM and then the clicked element is not on the DOM anymore.
            if (!isClickedOnFilterIcon && !isClickedOnDatePickerIcon) {
                this._closeView();
            }
        },

        _onCloseButtonClick: function(){
            this._closeView();
        },

        _closeView: function (event) {
            this.close();
        }
    });

    GridViewFilterLayout.FILTER_TYPES = FILTER_TYPES;

    return GridViewFilterLayout;
});
